import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

import { AddCollaboratorSteps } from './use-collaborator-details-form';

function useCollaboratorFormTitles(step?: AddCollaboratorSteps) {
  const { t } = useTranslation('collaborators-page');

  const formMainTitle = useMemo(
    () =>
      step === AddCollaboratorSteps.CHOOSE_PERMISSION_LEVEL
        ? t('choose_permission_level')
        : t('invite_a_new_collaborator_on_restworld'),
    [step, t]
  );

  const formSubtitleEl = useMemo(
    () =>
      step === AddCollaboratorSteps.FILL_INFO ? (
        <span>{`${t('managing_all_the_applications_is_not_an_easy_job')}. ${t(
          'by_inviting_your_collaborators_you_will_be_able_to_manage_the_workload_better'
        )}, ${t('not_bad_eh')}`}</span>
      ) : (
        <div>
          <p className="mb-4">
            <strong>{t('admin_level_collaborators')}:</strong>{' '}
            {t('have_access_to_all_pages_and_information_including_collaborators_payment_methods_and_invoices')}.
          </p>
          <p>
            <strong>{t('base_level_collaborators')}:</strong>{' '}
            {t('have_limited_access_to_restaurants_job_positions_and_spontaneous_candidates')}{' '}
          </p>
        </div>
      ),
    [step, t]
  );

  return { formMainTitle, formSubtitleEl };
}
export default useCollaboratorFormTitles;
